goog.provide('el8.tourguide.passportHome');

goog.require('el8.tourguide.util');
goog.require('el8.tourguide.homeInfoSplash');
goog.require('el8.tourguide.homeSuggestChart');


el8.tourguide.passportHome.init = function() {

    el8.tourguide.util.manageSplash({
        startTriggerFn: function() {
            // no action
        }
    });

};



